module.exports = __webpack_public_path__ + "img/empty-plan.56889cf1.png";